import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../..';
import { IAppSliceConfig } from '../../../types';
import { pollWindowVariables } from '../../../utils';
import { fetchProducts } from '../products/products';

interface IAppSlice {
  loading: boolean;
  config: IAppSliceConfig;
}

const app = createSlice({
  name: 'app',
  initialState: {
    loading: true,
    config: {
      currency: null,
      localeId: '',
      siteId: ''
    }
  } as IAppSlice,
  reducers: {
    setupStarted(state) {
      state.loading = true;
    },
    setupApp(state, action: PayloadAction<IAppSliceConfig>) {
      state.config = action.payload;
      state.loading = false;
    }
  }
});

export const { setupStarted, setupApp } = app.actions;

export default app.reducer;

export const fetchAppSetup = (productIds?: string[]) => async (
  dispatch: AppDispatch
) => {
  try {
    dispatch(setupStarted());
    const windowVariablesPromises = await pollWindowVariables([
      'GeoRestrictedResources',
      'Constants'
    ]);

    const promiseValues = await Promise.all(windowVariablesPromises);
    const config: IAppSliceConfig = {
      currency: (promiseValues[0] as any).STOREFRONT_CURRENCY_CODE,
      localeId: (promiseValues[0] as any).STOREFRONT_CURRENT_LOCALE,
      siteId: (promiseValues[1] as any).SITE_ID
    };

    // Fetch products if productIds parameters is provided
    if (productIds && productIds.length) {
      await dispatch(fetchProducts(config, productIds));
    }

    // Eventually set the app loading status
    await dispatch(setupApp(config));
  } catch (error) {
    console.log('App Setup Error: ', error);
  }
};
